/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource, createEmptyStateResource } from '@common/tech-shared';
import { UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { VorgangHeaderLinkRel, VorgangWithEingangResource } from '@alfa-client/vorgang-shared';
import { Component, Input, OnChanges, inject } from '@angular/core';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'alfa-user-profile-in-vorgang-container',
  templateUrl: './user-profile-in-vorgang-container.component.html',
  standalone: false,
})
export class UserProfileInVorgangContainerComponent implements OnChanges {
  service = inject(UserProfileService);

  @Input() vorgang: VorgangWithEingangResource;

  userProfile$: Observable<StateResource<UserProfileResource>> = of(createEmptyStateResource<UserProfileResource>());

  ngOnChanges(): void {
    this.userProfile$ = this.service.getAssignedUserProfile(this.vorgang, VorgangHeaderLinkRel.ASSIGNED_TO);
  }
}
